<template>
    <div>   <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose"
    >
        <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
            <a-form-model-item
                    ref="name"
                    label="名称"
                    prop="name"
                    :help="formErr.name"
                    :validateStatus='!formErr.name||formErr.name==""?"":"error"'
            >
                <a-input
                        :maxLength=50
                        v-model="form.name"
                        @change="(e) => { formErr.name=''}"
                        @blur="(e) => {  form.name = e.target.value.trim() }"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="url"
                    label="链接地址"
                    prop="url"
                    :help="formErr.url"
                    :validateStatus='!formErr.url||formErr.url==""?"":"error"'
            >
                <a-input
                        :maxLength=200
                        v-model="form.url"
                        @change="(e) => { formErr.url=''}"
                        @blur="(e) => {  form.url = e.target.value.trim() }"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="target"
                    label="打开方式"
                    prop="target"
                    :help="formErr.target"
                    :validateStatus='!formErr.target||formErr.target==""?"":"error"'
            >
                <a-select v-model="form.target">
                    <a-select-option  value="_blank"  >
                       新标签页打开
                    </a-select-option>
                    <a-select-option  value="_self"  >
                        本窗口打开
                    </a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item
                    ref="status"
                    label="状态"
                    prop="status"
                    :extra="formErr.status"
                    :validateStatus='!formErr.status||formErr.status==""?"":"error"'
            >
            <a-radio-group v-model="form.status"  >
                <a-radio :value="1"> 显示 </a-radio>
                <a-radio :value="0"> 隐藏 </a-radio>
            </a-radio-group>
            </a-form-model-item>
        </a-form-model>
        <div class="drawer-btn"  >

            <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                确定
            </a-button>
            <a-button @click="onClose">
            取消
        </a-button>
        </div>
    </a-drawer></div>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../../utils/utils"
    import API from "../api";
    export default {
        name: "linksForm",
        props: ["visible","title","editId"],
        data() {
            return {
                drawerConfig,
                form: {
                    status:1,
                    url:"",
                    target:"_blank",
                    name:""
                },
                formErr: {
                    status:"",
                    url:"",
                    target:"",
                    name:""
                },
                rules: {
                    name: [{required: true, message: "请输入名称 ", trigger: "blur"},{ whitespace: true, message: "请输入名称 " },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.name)}  , trigger: "blur"  }, ],
                    url: [{required: true, message: "请输入链接地址 ", trigger: "blur"}, {  whitespace: true, message: "请输入链接地址 " },{type:"url", message: "请填写正确链接地址"},{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.url)}  , trigger: "blur"  },],
                },
                layout: {
                    labelCol: { span: 4 },
                    wrapperCol: { span: 14 },
                },
            };
        },
        watch:{
            editId: function (a, b) {
                if (a != "") {
                    API.link.EDIT_DATA({id: a}).then(res => {
                        let val = res.data.data.info
                        this.form = val
                    })
                } else {
                    this.form.id = ''
                }
            }
        },
        methods: {
            onClose() {
                this.$emit("changVisible", false);
                this.formErr={ status:"",  url:"", target:"",  name:"" }
                this.$refs.ruleForm.resetFields();
            },
            onSubmit() {
                let _this = this;
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        this.form.id == '' || this.form.id == undefined ? url = API.link.SUBMIT_ADD : url = API.link.SUBMIT_EDIT
                        submitForm(url, _this.form).then(res => {
                            if (res == true) {
                                this.onClose()
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>

</style>
